import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c93c0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-top priority" }
const _hoisted_2 = { class: "main_title" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "스톡옵션", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_7 = {
  id: "stockOption__my_stock",
  ref: "topContainer",
  key: 'mystock',
  class: "main_content"
}
const _hoisted_8 = { class: "stock_content" }
const _hoisted_9 = { class: "col_left" }
const _hoisted_10 = { class: "c_logo" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_13 = { class: "col_right" }
const _hoisted_14 = { class: "space-between" }
const _hoisted_15 = { class: "regular bold" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "space-between" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "수량", -1))
const _hoisted_19 = { class: "strong" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 주")
const _hoisted_21 = { class: "space-between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "주당 행사가격", -1))
const _hoisted_23 = { class: "strong" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_25 = { class: "space-between" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "계약체결일", -1))
const _hoisted_27 = { class: "space-between" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "행사가능기간", -1))
const _hoisted_29 = { class: "space-between" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "행사 필요 금액", -1))
const _hoisted_31 = { class: "strong" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_33 = { class: "space-between" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  id: "stockOption__calculator",
  ref: "calcTabObj",
  key: 'calc',
  class: "content",
  style: {"background-color":"#4360EC"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 스톡옵션 세금 계산기 "),
  /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
    /*#__PURE__*/_createTextVNode(" 내 스톡옵션, 행사하면 얼마가 되는 걸까요? "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 간단한 정보를 입력하고 필요 자금과 세금을 계산해 보세요 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "detail_info" }, " 본 스톡옵션 세금 계산기는 아주 단순화된 것으로 참고용으로만 사용하시기 바라며, 실제 부과될 세금은 다를 수 있으니 실제 행사시에는 세무 전문가와 상의하기시를 바랍니다. ")
], -1))
const _hoisted_37 = { class: "calc_content" }
const _hoisted_38 = { class: "calc_input" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calc_title" }, " 회사 이름 ", -1))
const _hoisted_40 = { class: "wbox" }
const _hoisted_41 = { class: "calc_input" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calc_title" }, " 주당 행사가격 ", -1))
const _hoisted_43 = { class: "wbox space-between" }
const _hoisted_44 = { class: "input_info" }
const _hoisted_45 = { class: "calc_input" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calc_title" }, " 스톡옵션 행사로 받을 주식의 수 ", -1))
const _hoisted_47 = { class: "wbox space-between" }
const _hoisted_48 = { class: "input_info" }
const _hoisted_49 = { class: "calc_input" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calc_title" }, " 근로소득(연봉) ", -1))
const _hoisted_51 = { class: "wbox space-between" }
const _hoisted_52 = { class: "input_info" }
const _hoisted_53 = { class: "calc_input" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calc_title" }, " 주당 예상 판매가(예상 양도가) ", -1))
const _hoisted_55 = { class: "wbox space-between" }
const _hoisted_56 = { class: "input_info" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "calc_arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/arrow-down.png",
    srcset: "/assets/icon/arrow-down@2x.png 2x,/assets/icon/arrow-down@3x.png 3x"
  })
], -1))
const _hoisted_58 = { class: "calc_result" }
const _hoisted_59 = { class: "row space-between" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "스톡옵션 행사에 필요한 자금", -1))
const _hoisted_61 = {
  key: 0,
  class: "strong"
}
const _hoisted_62 = {
  key: 1,
  class: "strong"
}
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_64 = { class: "row space-between" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "매도수익(매도가 - 행사가)", -1))
const _hoisted_66 = {
  key: 0,
  class: "strong"
}
const _hoisted_67 = {
  key: 1,
  class: "strong"
}
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_69 = { class: "row space-between" }
const _hoisted_70 = { class: "center" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "추가 근로소득세", -1))
const _hoisted_72 = {
  key: 0,
  class: "strong"
}
const _hoisted_73 = {
  key: 1,
  class: "strong"
}
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_75 = { class: "row space-between" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "양도소득세(10%)", -1))
const _hoisted_77 = {
  key: 0,
  class: "strong"
}
const _hoisted_78 = {
  key: 1,
  class: "strong"
}
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_80 = { class: "row space-between" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "지방소득세(양도소득세의 10%)", -1))
const _hoisted_82 = {
  key: 0,
  class: "strong"
}
const _hoisted_83 = {
  key: 1,
  class: "strong"
}
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_85 = { class: "row space-between" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "증권거래세(0.45%)", -1))
const _hoisted_87 = {
  key: 0,
  class: "strong"
}
const _hoisted_88 = {
  key: 1,
  class: "strong"
}
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_90 = { class: "calc_total space-between" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "주머니에 남는 자금", -1))
const _hoisted_92 = {
  key: 0,
  class: "strong"
}
const _hoisted_93 = {
  key: 1,
  class: "strong"
}
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_95 = { class: "calc_share" }
const _hoisted_96 = { class: "space-between" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col_left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "share_img",
    src: "/assets/icon/angel.png",
    srcset: "/assets/icon/angel@2x.png 2x,/assets/icon/angel@3x.png 3x"
  })
], -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share_title" }, " MY자산 등록하면 100,000P 적립! > ", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share_info" }, " 계산한 정보를 MY 스톡옵션에 등록해서 관리하세요 ", -1))
const _hoisted_100 = [
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sell_info" }, " 스톡옵션 이미 행사하셨다면? ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        id: "stock__ionContent",
        fullscreen: true,
        "scroll-events": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "ion-activatable ripple-parent btn-back",
                  onClick: _cache[0] || (_cache[0] = () => {
                _ctx.$clickTrackEvent({'clickArea':'헤더', 'clickContent':'뒤로가기', clickScreen: _ctx.clickScreen})
                _ctx.router.push('/tabs/mypage')
              })
                }, [
                  _hoisted_4,
                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                ]),
                _hoisted_5
              ])
            ])
          ]),
          _hoisted_6,
          (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "add_btn",
              onClick: _cache[1] || (_cache[1] = () => {
            _ctx.$clickTrackEvent({'clickArea':'상단버튼', 'clickContent':'스톡옵션 추가', clickScreen: _ctx.clickScreen});
            (_ctx.user === null ? _ctx.$global.openLoginModal(): _ctx.createModal('add'))
          })
            }, " + 스톡옵션 추가 "),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockOption, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: "content_box"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: item.companyLogo ? item.companyLogo : '/assets/icon/company_default_img.png',
                        onerror: "this.src='/assets/icon/company_default_img.png'",
                        class: "img-responsive img-circle"
                      }, null, 8, _hoisted_11),
                      _hoisted_12
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(item.companyName), 1),
                      _createElementVNode("img", {
                        class: "edit_img",
                        src: "/assets/icon/edit.png",
                        srcset: "/assets/icon/edit@2x.png 2x,/assets/icon/edit@3x.png 3x",
                        onClick: ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'스톡옵션 목록', 'clickContent':'수정버튼', clickScreen: _ctx.clickScreen});_ctx.createModal('edit', item)}
                      }, null, 8, _hoisted_16)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$filters.currency(item.exerciseQty)), 1),
                        _hoisted_20
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$filters.currency(item.exercisePrice)), 1),
                        _hoisted_24
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", null, _toDisplayString(item.contractDateDot), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", null, _toDisplayString(item.exercisePeriod), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$filters.currency(item.asset)), 1),
                        _hoisted_32
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", {
                        innerHTML: _ctx.stockOptionPeriod(item.exercisePeriod)
                      }, null, 8, _hoisted_34)
                    ])
                  ])
                ]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.stockOption]
            ])
          ], 512)),
          (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.calcInfo.companyName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.calcInfo.companyName) = $event)),
                    type: "text",
                    maxlength: "13"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_ion_input, {
                    id: "inputPrice",
                    modelValue: _ctx.calcInfo.exercisePrice,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.calcInfo.exercisePrice) = $event)),
                    placeholder: "0",
                    type: "number",
                    class: "strong",
                    onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isValidInput($event)))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.numToHan(_ctx.calcInfo.exercisePrice)) + "원 ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.calcInfo.exerciseQty,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.calcInfo.exerciseQty) = $event)),
                    type: "number",
                    placeholder: "0",
                    class: "strong",
                    onKeydown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isValidInput($event)))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.numToHan(_ctx.calcInfo.exerciseQty)) + "주 ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.calcInfo.annualIncome,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.calcInfo.annualIncome) = $event)),
                    type: "number",
                    placeholder: "0",
                    class: "strong",
                    onKeydown: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isValidInput($event)))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.numToHan(_ctx.calcInfo.annualIncome)) + "원 ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.calcInfo.handoverPrice,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.calcInfo.handoverPrice) = $event)),
                    type: "number",
                    placeholder: "0",
                    class: "strong",
                    onKeydown: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isValidInput($event)))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.numToHan(_ctx.calcInfo.handoverPrice)) + "원 ", 1)
                ])
              ]),
              _createElementVNode("button", {
                ref: "firstInput",
                class: "calc_btn",
                onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'스톡옵션 세금 계산기', 'clickContent':'계산하기', clickScreen: _ctx.clickScreen});_ctx.calcStock()})
              }, " 계산하기 ", 512),
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("div", null, [
                    (_ctx.calcResult != '' || !_ctx.calcResult)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$filters.currency(_ctx.calcResult.exerciseAsset)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_62, "0")),
                    _hoisted_63
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("div", null, [
                    (_ctx.calcResult != '' || !_ctx.calcResult)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.$filters.currency(_ctx.calcResult.sellIncome)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_67, "0")),
                    _hoisted_68
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("img", {
                      class: "help_circle help_circle_img",
                      src: "/assets/icon/help_circle@3x.png",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'스톡옵션 세금 계산기', 'clickContent':'추가 근로소득세 툴팁', clickScreen: _ctx.clickScreen});_ctx.openPopover()})
                    })
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.calcResult != '' || !_ctx.calcResult)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(_ctx.$filters.currency(_ctx.calcResult.salaryTaxGap)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_73, "0")),
                    _hoisted_74
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _hoisted_76,
                  _createElementVNode("div", null, [
                    (_ctx.calcResult != '' || !_ctx.calcResult)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_ctx.$filters.currency(_ctx.calcResult.handoverTax)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_78, "0")),
                    _hoisted_79
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _hoisted_81,
                  _createElementVNode("div", null, [
                    (_ctx.calcResult != '' || !_ctx.calcResult)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_ctx.$filters.currency(_ctx.calcResult.countryTax)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_83, "0")),
                    _hoisted_84
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _hoisted_86,
                  _createElementVNode("div", null, [
                    (_ctx.calcResult != '' || !_ctx.calcResult)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString(_ctx.$filters.currency(_ctx.calcResult.tradeTax)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_88, "0")),
                    _hoisted_89
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_90, [
                _hoisted_91,
                _createElementVNode("div", null, [
                  (_ctx.calcResult != '' || !_ctx.calcResult)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(_ctx.$filters.currency(_ctx.calcResult.inMyPocket)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_93, "0")),
                  _hoisted_94
                ])
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, [
                  _hoisted_97,
                  _createElementVNode("div", {
                    class: "col_right",
                    onClick: _cache[13] || (_cache[13] = () => {
                  _ctx.$clickTrackEvent({'clickArea':'스톡옵션 세금 계산기', 'clickContent':'MY자산 등록하면 100,000P 적립', clickScreen: _ctx.clickScreen});
                  (_ctx.user === null ? _ctx.$global.openLoginModal(): _ctx.createModal('add'))
                })
                  }, _hoisted_100)
                ])
              ]),
              _hoisted_101,
              _createElementVNode("div", {
                class: "sell_btn",
                onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'스톡옵션 세금 계산기', 'clickContent':'주식 팔기', clickScreen: _ctx.clickScreen});_ctx.openSellModal()})
              }, " 주식 팔기 ")
            ])
          ], 512))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}